import { useSelector } from 'react-redux';
import { useAPIReducer } from '~/api/helpers';
import { APIHookResponse } from '~/api/types';
import { Actions } from '~/store/logout/actions';
import { getLogoutError, getLogoutSuccess } from '~/store/logout/selectors';

export const useLogout = (): APIHookResponse => {
  const success = useSelector(getLogoutSuccess);
  const logoutError = useSelector(getLogoutError);
  const useAPI = useAPIReducer(Actions.LOGOUT_REQUEST);
  const apiState = useAPI(success, logoutError);
  return apiState;
};
